import { render, staticRenderFns } from "./SelectCompanyModal.vue?vue&type=template&id=230b46e6"
import script from "./SelectCompanyModal.vue?vue&type=script&lang=js"
export * from "./SelectCompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports